import { Vector3, Euler } from "three";

export interface EnvironmentElement {
  id: string;
  type: EnvironmentElementType;
  position: Vector3;
  rotation: Euler;
  scale: number;
}

export interface AirplaneEnvironmentElement extends EnvironmentElement {
  data: {
    message: string;
    color: string;
    path?: { start: Vector3; end: Vector3 };
    speed?: number;
  };
}

export enum EnvironmentElementType {
  ROCK = "ROCK",
  TREE = "TREE",
  MUD = "MUD",
  GRASS = "GRASS",
  BILLBOARD = "BILLBOARD",
  AIRPLANE = "AIRPLANE",
}

export interface ChunkData {
  chunkId: string; // np. "x0_y0"
  elements: EnvironmentElement[];
}

export interface ChunkPosition {
  x: number;
  z: number;
}

// Stałe konfiguracyjne
export const CHUNK_SIZE = 100; // Rozmiar chunka w jednostkach świata
export const RENDER_DISTANCE = 1; // Ile chunków wokół gracza renderować
